"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthToken = void 0;

var _limiter = require("./limiter");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getAuthToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", (0, _limiter.limiter)({
              name: "getAuthToken"
            }, /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(success, failure) {
                var url, result, resp, json;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        url = "".concat(process.env.REACT_APP_WEB_API, "/webapp/users/self/token");
                        result = null;
                        _context.prev = 2;
                        _context.next = 5;
                        return fetch(url, {
                          method: "GET",
                          mode: "cors",
                          credentials: "include"
                        });

                      case 5:
                        resp = _context.sent;
                        _context.next = 8;
                        return resp.json();

                      case 8:
                        json = _context.sent;
                        result = null;

                        if (json && json.success) {
                          result = json.data;
                        }

                        _context.next = 16;
                        break;

                      case 13:
                        _context.prev = 13;
                        _context.t0 = _context["catch"](2);
                        result = {
                          user_id: 0,
                          token: "",
                          timestamp: Date.now()
                        };

                      case 16:
                        return _context.abrupt("return", result);

                      case 17:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[2, 13]]);
              }));

              return function (_x, _x2) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAuthToken() {
    return _ref.apply(this, arguments);
  };
}();

exports.getAuthToken = getAuthToken;